import React from 'react'
import { View } from 'react-native'

import { useStepContentText } from '@flows-ui/utils/useStepContentText'
import type { Tag as TagProps } from '@flows/core/types/stepContentTypes'
import type { FlowValues } from '@flows/core/types/stepTypes'
import UiKitTag from '@ui-kit/components/Tag'

interface Props extends TagProps {
  flowValues: FlowValues
}

export const Tag = (props: Props) => {
  const translateFunction = useStepContentText(props.flowValues)

  return (
    <View className="flex-row">
      <UiKitTag
        label={translateFunction(props.label)}
        type="infoSecondary"
        bgColor="grey200"
        textClass="text-black"
      />
    </View>
  )
}
